<template>
<v-col cols="12" sm="12" class=" mt-2">
  <v-row>
    <v-col cols="3" sm="2">
      <h3>مانده فعلی :</h3>
    </v-col>
    <v-col cols="3" sm="4">
      <h3 class="balance mt-n2" v-if="type !== 'lendingBill'">{{balance.toLocaleString()}}</h3>
      <h3 class="balance mt-n2" v-if="type === 'lendingBill'">{{lendingBalance}}</h3>
    </v-col>
    <v-col cols="3" sm="6" v-if="route === 'persons'">
      <h3 class="mahiat">{{mahiat}}</h3>
    </v-col>
  </v-row>
</v-col>
</template>
<script>
//
import {
  doubleDisplay
} from '../../functions/utils'

export default {
  name: 'MyBalance',
  props: ['balance', 'type', 'route', 'product'],
  data() {
    return {
      mahiat: 'بی حساب',
      lendingBalance: 0,
    }
  },
  watch: {
    balance: {
      handler(newVal) {
        if (this.route !== 'persons') return
        if (this.type === 'lendingBill') {
          this.lendingBalance = `${doubleDisplay(this.balance)} ${this.product.unit1} = ${doubleDisplay(this.balance / this.product.n)} ${this.product.unit2}`
        }
        if (newVal == 0) this.mahiat = 'بی حساب'
        if (newVal > 0) this.mahiat = 'بدهکار'
        if (newVal < 0) this.mahiat = 'بستانکار'
      },
      deep: true
    },
  }
}
</script>
<style lang="scss">
.title {
    color: darkgrey;
}

.balance {
    font-size: 24px;
    color: blue;
}

.mahiat {
    font-size: 24px;
    color: green;
}
</style>
